import { render, staticRenderFns } from "./SignaturesListElement.vue?vue&type=template&id=3efd7098&scoped=true"
import script from "./SignaturesListElement.vue?vue&type=script&lang=js"
export * from "./SignaturesListElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd7098",
  null
  
)

export default component.exports